
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"i-fill",attrs:{"cx":"22.933","cy":"24.672","r":"12.794","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Ellipse 594",attrs:{"d":"M23.169 4.084a20.595 20.595 0 0 1 20.15 17.57","stroke":"#234652"}}),_c('path',{staticClass:"i-Ellipse 597",attrs:{"d":"M40.992 34.603a20.595 20.595 0 0 1-28.575 7.773","stroke":"#234652"}}),_c('path',{staticClass:"i-Ellipse 598",attrs:{"d":"M4.429 33.689a20.594 20.594 0 0 1 6.682-25.865","stroke":"#234652"}}),_c('path',{staticClass:"i-Ellipse 599",attrs:{"d":"M21.166 6.538a2.554 2.554 0 1 1-.98-5.014 2.554 2.554 0 0 1 .98 5.014Z","stroke":"#234652"}}),_c('path',{staticClass:"i-Ellipse 600",attrs:{"d":"M42.81 34.515a2.555 2.555 0 1 1-.982-5.014 2.555 2.555 0 0 1 .981 5.014Z","stroke":"#234652"}}),_c('path',{staticClass:"i-Ellipse 601",attrs:{"d":"M5.75 38.102a2.554 2.554 0 1 1-.87-5.033 2.554 2.554 0 0 1 .87 5.033Z","stroke":"#234652"}}),_c('path',{staticClass:"i-Line 122",attrs:{"stroke":"#234652","d":"M22.886 19.526v10.223"}}),_c('path',{staticClass:"i-Line 123",attrs:{"stroke":"#234652","d":"M28.077 24.652H17.854"}}),_c('path',{staticClass:"i-Rectangle 915",attrs:{"d":"m6.808 7.145 4.732.477-.476 4.733","stroke":"#234652"}}),_c('path',{staticClass:"i-Rectangle 916",attrs:{"d":"m46.09 18.417-2.674 3.935-3.935-2.673","stroke":"#234652"}}),_c('path',{staticClass:"i-Rectangle 917",attrs:{"d":"m13.25 46.495-1.397-4.547 4.546-1.398","stroke":"#234652"}})])
          )
        }
      }
    